import Settings, { SettingNamespace } from "./settings";
import { convertDateToUTC, compareDates, getDayFromDate } from "./utilities";
import { Schedule } from "./types";

export async function isStoreOpen() {
    const settings = await Settings.getInstance();

    const scheduleSettings = settings.get(SettingNamespace.OPENINGS, 'online_schedule');
    const today = getDayFromDate(new Date());
    const schedule = scheduleSettings!.value.find((schedule: Schedule) => schedule.name === today);

    let unavailabilities = settings.get(SettingNamespace.OPENINGS, 'unavailabilities');
    const storeClosed = settings.get(SettingNamespace.OPENINGS, 'close_store');

    if (storeClosed !== undefined && storeClosed.value === true) {
        return false;
    }
    
    if (schedule !== undefined) {
        const now = new Date();
        const openingTime = new Date();
        const closingTime = new Date();
        let isHoliday = false;

        let startTime = schedule.start_time.split(':');
        let endTime = schedule.end_time.split(':');

        if (unavailabilities !== undefined) {
            unavailabilities = unavailabilities.value;
            for (let index = 0; index < (<any>unavailabilities).length; index++) {
                const unavail = (<any>unavailabilities)[index];
                const unavailDate = convertDateToUTC(new Date(unavail.date));
                if (unavail.repeat) {
                    unavailDate.setFullYear((new Date()).getFullYear());
                }
                if (compareDates(now, unavailDate)) {
                    if (!unavail.override_openings) {
                        isHoliday = true;
                        break;
                    }
                    startTime = unavail.openings.start_time.split(':');
                    endTime = unavail.openings.end_time.split(':');
                }
            }
        }

        openingTime.setHours(startTime[0]);
        openingTime.setMinutes(startTime[1]);
        openingTime.setSeconds(0);
        closingTime.setHours(endTime[0]);
        closingTime.setMinutes(endTime[1]);
        closingTime.setSeconds(0);

        if (isHoliday || schedule.isClosed || now < openingTime || now > closingTime) {
            return false;
        }
    }
    return true;
}
